export default __webpack_public_path__ + "fork-and-knife-silhouette.png";